<template>
  <div class="mr-2 d-inline-block">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          icon 
          small 
          v-bind="attrs" 
          v-on="on" 
          :color="article.consume.length > 0 ? 'success' : 'grey darken-1'"
          class="grey lighten-4 shadow-xs"
          @click="toogleDisplay"
        >
          <v-icon x-small>fas fa-basket-shopping</v-icon>
        </v-btn>
      </template>
      <span>{{ article.consume.length > 0 ? 'Editar consumo por OT' : 'Asignar consumo por OT' }}</span>
    </v-tooltip>

    <v-dialog persistent v-model="display" max-width="600" transition="dialog-bottom-transition">
      <v-card outlined class="modern-card overflow-hidden">
        <!-- Premium Header -->
        <v-sheet color="primary" class="pa-6 d-flex align-center">
          <v-avatar size="44" color="white opacity-20" class="mr-4 shadow-sm">
            <v-icon color="white">fas fa-basket-shopping</v-icon>
          </v-avatar>
          <div>
            <div class="caption white--text opacity-80 font-weight-black text-uppercase tracking-widest mb-1">Asignación de Consumo</div>
            <div class="text-h5 white--text font-weight-black lh-1-2 text-truncate" style="max-width: 350px">
              [{{article.sku}}] {{article.name}}
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon color="white" small @click="cancel">
            <v-icon x-small>fas fa-times</v-icon>
          </v-btn>
        </v-sheet>

        <v-card-text class="pa-6">
          <!-- Article Units Info -->
          <div class="d-flex flex-wrap gap-2 mb-6">
            <v-chip outlined label x-small class="font-weight-black py-3 px-3">
              <v-icon left x-small color="primary">fas fa-scale-balanced</v-icon>
              COMPRA: <span class="primary--text ml-1">{{article.unit_name}}</span>
            </v-chip>
            <v-chip outlined label x-small class="font-weight-black py-3 px-3">
              <v-icon left x-small color="success">fas fa-hand-holding-hand</v-icon>
              CONSUMO: <span class="success--text ml-1">{{article.unit_consume_name || article.unit_name}}</span>
            </v-chip>
            <v-chip outlined label x-small class="font-weight-black py-3 px-3">
              <v-icon left x-small color="amber darken-2">fas fa-arrow-right-arrow-left</v-icon>
              FACTOR: <span class="amber--text text--darken-4 ml-1">{{article.unit_consume_factor}}</span>
            </v-chip>
          </div>

          <!-- Entries Table -->
          <v-card outlined class="modern-card shadow-xs overflow-hidden">
            <v-simple-table dense class="modern-table">
              <thead>
                <tr>
                  <th class="caption font-weight-black grey--text uppercase tracking-wider py-3 px-4">Orden de Trabajo</th>
                  <th class="caption font-weight-black grey--text uppercase tracking-wider py-3 px-4" width="120">Cantidad</th>
                  <th class="caption font-weight-black grey--text uppercase tracking-wider py-3 px-4 text-center" width="60"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items" :key="index">
                  <td class="px-4 py-2">
                    <v-text-field
                      v-model='item.work_order'
                      placeholder="N° orden de trabajo..."
                      outlined dense hide-details
                      class="modern-input-minimal"
                      :append-icon="item.work_order_finded ? 'fas fa-check-circle' : 'fas fa-search'"
                      :loading="item.loadingWorkOrder"
                      @keydown="searchWorkOrder(item)"
                      :color="item.work_order_finded ? 'success' : 'primary'"
                    />
                  </td>
                  <td class="px-4 py-2">
                    <v-text-field
                      v-model.number="item.qty"
                      type="number"
                      min="1"
                      outlined dense hide-details
                      class="modern-input-minimal text-center"
                    />
                  </td>
                  <td class="text-center px-4 py-2">
                    <v-btn icon x-small color="error" class="grey lighten-5" @click.stop="removeItem(item)">
                      <v-icon x-small>fas fa-trash</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" class="pa-0">
                    <v-btn 
                      block 
                      tile 
                      depressed 
                      color="grey lighten-4" 
                      class="caption font-weight-black primary--text py-6"
                      @click.stop="addRow"
                    >
                      <v-icon x-small left>fas fa-plus</v-icon>
                      AGREGAR LÍNEA DE CONSUMO
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>

          <!-- Totals Area -->
          <div class="mt-8 pa-4 bg-lightgrey rounded-lg border-dashed">
            <v-row no-gutters align="center">
              <v-col cols="12" class="text-center pr-2 border-right">
                <div class="caption grey--text font-weight-bold uppercase tracking-widest mb-1">Total Consumo</div>
                <div class="body-1 font-weight-black primary--text">
                  {{total | number('0,0.00')}} <span class="caption font-weight-medium grey--text">{{article.unit_consume_name || article.unit_name}}</span>
                </div>
              </v-col>
              <!-- <v-col cols="6" class="text-center pl-2">
                <div class="caption grey--text font-weight-bold uppercase tracking-widest mb-1">Impacto Stock</div>
                <div class="body-1 font-weight-black" :class="total_consume > article.qty ? 'error--text' : 'success--text'">
                  {{total_consume | number('0,0.00')}} <span class="caption font-weight-medium grey--text">{{article.unit_name}}</span>
                </div>
              </v-col> -->
            </v-row>
            <div v-if="total_consume > article.qty" class="mt-3 caption error--text font-italic text-center font-weight-bold">
              <v-icon x-small color="error" class="mr-1">fas fa-circle-exclamation</v-icon>
              Atención: El consumo excede la cantidad ingresada en el movimiento.
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 bg-lightgrey flex justify-end gap-2">
          <v-btn text class="caption font-weight-black px-6" @click="cancel">Cancelar</v-btn>
          <v-btn 
            color="primary" 
            class="px-8 font-weight-black shadow-sm"
            @click="save" 
            :disabled="cannotSave"
            :loading="loading"
          >
            Confirmar Asignación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {getWorkOrder,createConsumptionBitacoraByOT} from '@/api/production'
import notifications from '@/utils/notifications'
export default{
    name:'ConsumeByOT',
    props:['article','addConsume','transaction'],
    data(){
        return{
            display:false,
            text:'Consumo por OT',
            work_order: '',
            work_order_finded: false,
            loadingWorkOrder: false,
            loading: false,
            timer:'',
            items:[{
                work_order:'',
                qty:'',
                work_order_finded:false,
                loadingWorkOrder:false,
            }],
        }
    },
    methods:{
        async toogleDisplay(){
            this.display=!this.display
            if(this.display&&this.article.consume.length>0){
                this.items=[]
                this.article.consume.forEach(i=>this.items.push(i))
            }
        },
        searchWorkOrder(item) {  
      //Función para hacer búsqueda lazy
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(async () => {
            item.loadingWorkOrder = true
            await getWorkOrder(item.work_order)
            .then((data)=>{
                item.work_order_finded=true 
                item.loadingWorkOrder=false
                //const {customer_name,created_at,name}=data
                //this.work_order_details=`${customer_name} ${moment(created_at).format('DD/MM/yyy')} ${name}`
            })
            .catch((e)=>{
                notifications.showError('Orden de Trabajo no encontrada')
                item.work_order_finded=false
                item.loadingWorkOrder=false
            })
        }, 800);
        },
        addRow(){
            this.items.push({
                id:-1,
                work_order:'',
                qty:'',
                work_order_finded:false,
                loadingWorkOrder:false,
            })
        },
        removeItem(item){
            this.items.splice(this.items.indexOf(item),1)
        },
        async save(){
            this.article.consume=[]
            const filtered = this.items.filter(item=>item.work_order_finded&&item.qty)
            filtered.forEach(i=>this.article.consume.push(i))
            
            //Repito el codigo para cuando se actualiza una transaccion
            if(this.transaction){
                this.loading=true
                const consume_data=this.items.map(item=>({
                    article_id:this.article.id,
                    workorder_id:item.work_order,
                    articlePrice:parseFloat(this.article.avg),
                    convertedPrice:parseFloat(this.article.avg)*(this.article.unit_consume_factor||1),
                    qty:item.qty,
                    unit:this.article.unit_name,
                    unitConsume:this.article.unit_consume_name||this.article.unit_name,
                    unitConsume_factor:this.article.unit_consume_factor||1
                }))

                await createConsumptionBitacoraByOT({'transaction_id':this.transaction.id,consume_data})
                .then(()=>{
                    notifications.showSuccess('Consumos actualizados correctamente')
                    
                })
                .catch(err=>{
                    notifications.showError('Error creando Consumo '+err)
                    return 0
                })
                .finally(()=>{
                    this.loading=false
                })
            }
            this.items=[]
            this.display=false
        },
        cancel(){
            this.items=this.article.consume.length>0?[]:[{
                work_order:'',
                qty:'',
                work_order_finded:false,
                loadingWorkOrder:false,
            }]
            this.display=false
        }
    },
    computed:{
        total(){
            return this.items.filter(i=>i.work_order_finded).reduce((total,item)=>{
                return total+parseFloat(item.qty)
            },0)
        },
        total_consume(){
            return this.total*this.article.unit_consume_factor
        },
        cannotSave(){
            return this.items.filter(i=>!i.work_order_finded || !i.qty).length>0 
        }
    },

}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; border: 1px solid rgba(0,0,0,0.05) !important; background-color: white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important; }
.shadow-xs { box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important; }
.border-dashed { border: 2px dashed #e0e4e8 !important; }
.border-right { border-right: 1px solid #e0e4e8 !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.05) !important; }
.bg-lightgrey { background-color: #f8fbfc; }
.white-opacity-20 { background-color: rgba(255,255,255,0.2) !important; }
.lh-1-2 { line-height: 1.2 !important; }
.gap-2 { gap: 8px; }
.uppercase { text-transform: uppercase; }
.tracking-widest { letter-spacing: 2.2px; }
.tracking-wider { letter-spacing: 1.2px; }

.modern-input-minimal >>> .v-input__control fieldset { border-radius: 6px !important; border-color: #e0e4e8 !important; }
.modern-input-minimal >>> .v-input__control { background-color: white !important; }
.modern-input-minimal >>> input { font-size: 0.85rem !important; font-weight: 600 !important; color: #1a1f2e !important; }

.modern-table >>> thead th { background-color: #f8fbfc !important; height: 44px !important; }
.modern-table >>> td { height: 50px !important; border-bottom: 1px solid #f0f3f5 !important; }

.v-btn.shadow-sm { box-shadow: 0 4px 10px rgba(var(--v-primary-base), 0.2) !important; }
</style>